import { createContext } from 'react'

import { AuthStateContextType, AuthDispatchContextType, AuthPermissionsContextType } from './AuthContext.types'

export const AuthStateContext = createContext<AuthStateContextType | undefined>(undefined)
export const AuthDispatchContext = createContext<AuthDispatchContextType | undefined>(undefined)
export const AuthPermissionsContext = createContext<AuthPermissionsContextType | undefined>(undefined)
